import { AreaChart } from './areaChart';
import { ColumnMetaData } from './BaseProcessor';
import { ColumnChart } from './columnChart';
import { EcdfChart } from './ecdfChart';
import { EventplotChart } from './eventplotChart';
import { FillBetweenChart } from './fillBetweenChart';
import { LineChart } from './lineChart';
import { PieChart } from './pieChart';
import { ScatterChart } from './scatterChart';
import { StackBar } from './stackColumn';
import { StackplotChart } from './stackplotChart';
import { StemChart } from './stemCharts';
import { StairsChart } from './strairsChart';

export class ChartDataProcess {
  chartOptions: any = {};
  graphType: string;
  tableColumns: Array<string> = [];
  columnsMetaData: { [key: string]: ColumnMetaData };
  data: any;
  skipTableColumnSetToDefault: boolean = false;

  constructor(
    graphType: string,
    chartOptions: any,
    columnMetaData: { [key: string]: ColumnMetaData },
    data: any,
    tableColumns: Array<string> = [],
    skipTableColumnSetToDefault = false
  ) {
    this.graphType = graphType;
    this.chartOptions = chartOptions;
    this.tableColumns = tableColumns;
    this.columnsMetaData = columnMetaData;
    this.data = data;
    this.skipTableColumnSetToDefault = skipTableColumnSetToDefault;
  }

  protected getXAxisCols(): [string] | [] {
    if (!this.chartOptions?.xAxisCols && !this.skipTableColumnSetToDefault) {
      if (!this.chartOptions?.xAxis?.title?.text && this.tableColumns.length) {
        return [this.tableColumns[0]];
      }
      let xCols = this.chartOptions.xAxis.title.text
        .split('&')
        .map((item: any) => item.trim())
        .filter((col: string) => this.tableColumns.includes(col));
      if (xCols.length === 0) {
        if (this.tableColumns.length >= 1) {
          return [this.tableColumns[0]];
        } else {
          return [];
        }
      }
      return xCols;
    }
    return this.chartOptions?.xAxisCols || [];
  }
  protected getYAxisCols(): [string] | [] {
    if (!this.chartOptions?.yAxisCols && !this.skipTableColumnSetToDefault) {
      if (!this.chartOptions?.yAxis?.title?.text && this.tableColumns.length) {
        return [this.tableColumns[0]];
      }
      let yCols = this.chartOptions.yAxis.title.text
        .split('&')
        .map((item: any) => item.trim())
        .filter((col: string) => this.tableColumns.includes(col));
      if (yCols.length === 0) {
        if (this.tableColumns.length > 1) {
          return [this.tableColumns[1]];
        } else if (this.tableColumns.length === 1) {
          return [this.tableColumns[0]];
        } else {
          return [];
        }
      }
      return yCols;
    }
    return this.chartOptions?.yAxisCols || [];
  }

  getGroupBy(): [string] | [] {
    if (!this.chartOptions?.groupByCols && !this.skipTableColumnSetToDefault) {
      if (this.chartOptions?.group_by) {
        return [this.chartOptions.group_by];
      }
    }
    return this.chartOptions?.groupByCols || [];
  }

  processChartOptions() {
    let xAxisCols = this.getXAxisCols();
    let yAxisCols = this.getYAxisCols();
    let groupBy = this.getGroupBy();

    let chart: any;
    if (this.graphType === 'Line' || this.graphType === 'Plot') {
      chart = new LineChart(
        this.data,
        xAxisCols,
        yAxisCols,
        groupBy,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Bar' || this.graphType === 'Hist') {
      chart = new ColumnChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Pie') {
      chart = new PieChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Stem') {
      chart = new StemChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'StackBar') {
      chart = new StackBar(
        this.data,
        xAxisCols,
        yAxisCols,
        groupBy,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Area') {
      chart = new AreaChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Stackplot') {
      chart = new StackplotChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Eventplot') {
      chart = new EventplotChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Scatter') {
      chart = new ScatterChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Fill_Between') {
      chart = new FillBetweenChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Stairs') {
      chart = new StairsChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else if (this.graphType === 'Ecdf') {
      chart = new EcdfChart(
        this.data,
        xAxisCols,
        yAxisCols,
        this.columnsMetaData,
        this.chartOptions
      );
    } else {
      return;
    }
    this.chartOptions = chart.getChartOption();
    this.chartOptions.chart = {
      ...this.chartOptions.chart,
      zoomType: 'xy',
    };
    this.chartOptions.xAxisCols = xAxisCols;
    this.chartOptions.yAxisCols = yAxisCols;
    this.chartOptions.groupByCols = groupBy;
    return this.chartOptions;
  }
}
